import React from "react";
import classNames from "classnames";
import { TextArea as UITextArea, TextAreaProps } from "@stemscopes/ui";
import uniqueId from "lodash-es/uniqueId";
import { formHooks } from "../../form/duck";
import InputError from "../input-error";
import styles from "./TextArea.module.css";

const TextArea: React.FC<TextAreaProps> = ({
  name,
  className,
  labelClassName,
  textareaClassName,
  ...rest
}) => {
  const [field = {}, { error }] = formHooks.useField<string>({ name });
  const errorId = React.useMemo(() => uniqueId("error-"), []);

  return (
    <div>
      <UITextArea
        {...field}
        {...rest}
        className={classNames(styles.container, className)}
        labelClassName={classNames(styles.label, labelClassName)}
        textareaClassName={classNames(styles.textArea, textareaClassName, {
          [styles.error]: error,
        })}
        aria-errormessage={errorId}
        aria-invalid={!!error}
        // disable browser popup
        required={false}
        aria-required={!!rest.required}
      />
      <InputError error={error} errorId={errorId} />
    </div>
  );
};

export default TextArea;
